var _style, _path, _path2, _polygon, _polygon2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCssTechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F2F2F2;}\r\n\t.st1{fill:#006BC0;}\r\n\t.st2{fill:#0096DC;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#222123;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,22.5c0,7.2-3.4,13.7-8.7,17.8c-3.8,3-8.6,4.7-13.8,4.7s-10-1.8-13.8-4.7C3.4,36.2,0,29.7,0,22.5 C0,10.1,10.1,0,22.5,0S45,10.1,45,22.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,10.5l-2.6,29.8c-3.8,3-8.6,4.7-13.8,4.7s-10-1.8-13.8-4.7L6.2,10.5H38.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "22.5,13.3 22.5,44.4 33.2,41.4 35.6,13.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32,25.5 24.2,25.5 32.3,21.3 32.7,17.2 12.3,17.2 12.7,21.4 20.8,21.4 13,25.4 13.4,29.7 13.4,29.7  27.4,29.7 26.9,34.8 22.5,36 17.9,34.7 17.8,31.5 13.5,31.5 14.1,37.9 22.5,40.3 30.9,37.9 32,25.5 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "14.5,5.9 14.5,3 18.8,3 18.8,1.4 13,1.4 13,7.5 18.8,7.5 18.8,5.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "21.2,3.8 21.2,3 25.4,3 25.4,3 25.4,1.4 19.7,1.4 19.7,5.2 23.8,5.2 23.8,5.9 19.7,5.9 19.7,7.5  25.4,7.5 25.4,5.9 25.4,3.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "27.8,3.8 27.8,3 32,3 32,3 32,1.4 26.2,1.4 26.2,5.2 30.4,5.2 30.4,5.9 26.2,5.9 26.2,7.5 32,7.5  32,5.9 32,3.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssTechIcon);
export default __webpack_public_path__ + "static/media/css-tech-icon.83ef20e7cd8f7f15f842700d2fbe0d8e.svg";
export { ForwardRef as ReactComponent };